// extracted by mini-css-extract-plugin
module.exports = {"sider-light":"sider_sider-light__22v4a","sider-dark":"sider_sider-dark__1Cmz7"};